import React, { Component } from 'react';
import ConfigContainer from './ConfigContainer';
import Bottons from './Bottons';
export default class UISide extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initConfig: undefined,
      processPercent: undefined,
    };
  }
  componentWillReceiveProps(newProps) {
    const { loaded, api } = newProps;
    if (!this.props.loaded && loaded) {
      const initConfig = Object.keys(this.props.initConfig).length
        ? this.props.initConfig
        : api.configuration.getConfiguration();
      if (Object.keys(initConfig).length)
        this.setState({ initConfig: initConfig });
    }
  }

  render() {
    const { api, product, loaded, size, setAppState } = this.props;
    const { initConfig } = this.state;
    if (!loaded) return <div className="ui-side" style={{ height: '0px' }} />;
    return (
      <div className="ui-side">
        {<Bottons {...this.props} {...this.state} />}
        {initConfig &&
          <ConfigContainer
            api={api}
            configId={product.sceneId}
            form={product.form}
            callback={product.configUiCallback}
            configuration={this.state.initConfig}
            size={size}
            setAppState={setAppState}
          />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/UISide.js